import React from 'react'
import contentSet1Img from '../../assets/img/learn-more-content-set-1.webp'
import contentSet2Img from '../../assets/img/learn-more-content-set-2.webp'
import contentSet3Img from '../../assets/img/learn-more-content-set-3.webp'

export const getContentSets = (stationTitle) => [
  {
    key: 'content-set-1',
    title: (
      <span>
        Support {stationTitle}
        <br />
        and get extended access
      </span>
    ),
    description: (
      <span>
        {stationTitle} Passport is a member benefit that&#39;s available to
        donors who contribute an annual tax-deductible one-time gift of $60 or
        more, or an ongoing gift of $5 or more per month.
        <br />
        <br />
        With {stationTitle} Passport, you can stream more of your favorite PBS
        shows including Masterpiece, NOVA, Nature, Great Performances, and many
        more.
      </span>
    ),
    tts: `Support ${stationTitle} and get extended access ..... ${stationTitle} Passport is a member benefit that's available to donors who contribute an annual tax-deductible one-time gift of $60 or more, or an ongoing gift of $5 or more per month. With ${stationTitle} Passport, you can stream more of your favorite PBS shows including Masterpiece, NOVA, Nature, Great Performances, and many more.`,
    img: contentSet1Img,
  },
  {
    key: 'content-set-2',
    title: (
      <span>
        Get early access to
        <br />
        new shows
      </span>
    ),
    description: (
      <span>
        Get advance access to stream select new shows before they air on TV and
        binge-watch exclusive episodes with {stationTitle} Passport. Catch up on
        new and classic seasons of your favorite PBS shows on-demand.
        <br />
        <br />
        Look for the Passport symbol to spot videos that are available to watch
        exclusively with your member benefit.
      </span>
    ),
    tts: `Get early access to new shows ..... Get advance access to stream select new shows before they air on TV and binge-watch exclusive episodes with ${stationTitle} Passport. Catch up on new and classic seasons of your favorite PBS shows on-demand. Look for the Passport symbol to spot videos that are available to watch exclusively with your member benefit.`,
    img: contentSet2Img,
  },
  {
    key: 'content-set-3',
    title: (
      <span>
        Watch anytime,
        <br />
        on any screen
      </span>
    ),
    description: (
      <span>
        With {stationTitle} Passport, your favorite PBS shows are always on.
        Download the PBS App on your mobile phone and tablet to connect your{' '}
        {stationTitle} Passport membership and continue streaming local
        programs, news, dramas, documentaries, and more on-demand.
      </span>
    ),
    tts: `Watch anytime, on any screen ..... With ${stationTitle} Passport, your favorite PBS shows are always on. Download the PBS App on your mobile phone and tablet to connect your ${stationTitle} Passport membership and continue streaming local programs, news, dramas, documentaries, and more on-demand.`,
    img: contentSet3Img,
  },
]
